module.exports = __webpack_public_path__ + "static/media/contact.365de73b.png";